// extracted by mini-css-extract-plugin
export default {"cls1":"VeloGridLoading-HeadingSkeleton_cls1__FmygL","cls2":"VeloGridLoading-HeadingSkeleton_cls2__RVITh VeloGridLoading-HeadingSkeleton_cls1__FmygL"};